import { render, staticRenderFns } from "./ProcessHistories.vue?vue&type=template&id=8747f104&"
import script from "./ProcessHistories.vue?vue&type=script&lang=ts&"
export * from "./ProcessHistories.vue?vue&type=script&lang=ts&"
import style0 from "./ProcessHistories.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports